import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/lib/content";

const Faq = () => {
  return (
    <section
      data-testid="faq-section"
      className="relative bg-[#0B0410] text-[#F9F6F0] py-24 lg:py-32 border-t border-white/5"
    >
      <div className="max-w-3xl mx-auto px-6 lg:px-10">
        <div className="flex items-center gap-3 mb-8 justify-center">
          <span className="h-px w-10 bg-[#E6D5B8]" />
          <span className="text-[11px] tracking-luxury uppercase text-[#E6D5B8] font-medium">
            Preguntas frecuentes
          </span>
          <span className="h-px w-10 bg-[#E6D5B8]" />
        </div>
        <h2 className="font-display text-4xl sm:text-5xl font-light text-center leading-[1.1] mb-14">
          Lo que más nos preguntan{" "}
          <span className="italic text-[#E6D5B8]">antes</span> de empezar.
        </h2>

        <Accordion
          type="single"
          collapsible
          className="w-full"
          data-testid="faq-accordion"
        >
          {FAQS.map((f, idx) => (
            <AccordionItem
              key={idx}
              value={`item-${idx}`}
              data-testid={`faq-item-${idx}`}
              className="border-b border-white/10"
            >
              <AccordionTrigger className="text-left font-display text-xl lg:text-2xl font-light text-[#F9F6F0] hover:text-[#E6D5B8] hover:no-underline py-6">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm lg:text-base text-[#F9F6F0]/70 leading-relaxed pb-6 font-light">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default Faq;
